import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { PhClientModel } from '../../../model/index';
import { SmsService } from '../../../services/index';
import * as fromRootStore from '../../../reducers';
import { Store } from '@ngrx/store';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
    selector: 'smsPanelComponent',
    templateUrl: './smsPanel.component.html',
})

export class smsPanelComponent {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    @ViewChild('singleClientDetails') singleClientDetails;

    public mode: string;
    public list: any[] = [];
    public clientdata: any[] = [];

    isLoadMask: Promise<any>;
    clientData: PhClientModel[];
    excelData: any;
    isLoading: boolean;
    clientList: any;
    client: { content: any; mobile: any; name: any; };
    filterData;
    smsList: any;


    constructor(public store: Store<fromRootStore.State>,
        private SmsService: SmsService, private modalService: BsModalService, public toasterService: ToasterService) {
        this.isLoading = false;
        this.clientList = [];
        this.client = { name: '', mobile: '', content: '' };
        this.filterData = { from_date: new Date(), to_date: new Date(), client_name: null, mobile: null };
    }

    uploadFile(sheet) {
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        if ((sheet.target.files.length == 0) || (sheet.target.files.length < 0)) {
            return;
        }
        const file = sheet.target.files[0];
        reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary' });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                return initial;
            }, {});
            if (Object.keys(jsonData).length == 1) {
                // for (var j = 0; j < jsonData.Sheet1.length; j++) {
                //     jsonData.Sheet1[j].un_id = j;
                // }
                this.excelData = JSON.stringify(jsonData);
                this.clientList = jsonData.Sheet1;
            }
            else {
                this.excelData = '';
                sheet.srcElement.value = null;
                let toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'PLEASE UPLOAD THE FILE WITH ONLY ONE SHEET'
                };
                this.toasterService.pop(toast);
            }

            this.excelData = JSON.parse(this.excelData);

            for (var i = 0; i < this.excelData.Sheet1.length; i++) {

                if (!this.excelData.Sheet1[i].Client_Name || this.excelData.Sheet1[i].Client_Name == '') {
                    let toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: `PLEASE ENTER Client_Name ON ROW ${i + 1}`
                    };
                    this.toasterService.pop(toast);
                    this.excelData = undefined;
                    return;
                }
                else if (!this.excelData.Sheet1[i].Mobile_Number || this.excelData.Sheet1[i].Mobile_Number == '') {
                    let toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: `PLEASE ENTER Mobile_Number ON ROW ${i + 1}`
                    };
                    this.toasterService.pop(toast);
                    this.excelData = undefined;
                    return;
                }
                else if (!this.excelData.Sheet1[i].Content || this.excelData.Sheet1[i].Content == '') {
                    let toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: `PLEASE ENTER Content ON ROW ${i + 1}`
                    };
                    this.toasterService.pop(toast);
                    this.excelData = undefined;
                    return;
                }
                if (this.excelData.Sheet1[i].Mobile_Number && this.excelData.Sheet1[i].Mobile_Number != '') {
                    let mobLength = this.excelData.Sheet1[i].Mobile_Number.toString().length;
                    if (mobLength !== 10) {
                        let toast = {
                            type: 'error',
                            title: 'ERROR',
                            body: `PLEASE ENTER 10 DIGIT MOBILE NUMBER ON ROW ${i + 1}`
                        };
                        this.toasterService.pop(toast);
                        this.excelData = undefined;
                        return
                    }
                }
            }
            this.excelData = this.excelData.Sheet1;

            if (this.excelData.length === 0) {
                let toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'PLEASE ENTER VALUES IN EXCEL SHEET'
                };
                this.toasterService.pop(toast);
                return;
            }

        }
        reader.readAsBinaryString(file);

    }

    downloadFile() {
        let link = document.createElement("a");
        link.download = "assets/sampleExcel/SMS_Panel.xlsx";
        link.href = "assets/sampleExcel/SMS_Panel.xlsx";
        link.click();
    }

    saveSms(type: string) {
        let params = { data: null, type: null };
        params.type = type;
        params.data = type == 'Manual' ? this.client : this.excelData;

        if (params.type == 'Manual') {
            let mobLength = params.data.mobile.toString().length;
            if (mobLength !== 10) {
                let toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'PLEASE ENTER 10 DIGIT MOBILE NUMBER'
                };
                this.toasterService.pop(toast);
                return;
            }
        }

        this.isLoading = true;
        let that = this;

        if (type != '') {
            this.isLoadMask = this.SmsService
                .saveSms(params)
                .then(function (res: any) {
                    if (res.success) {
                        swal(res.message);
                    }
                    else {
                        swal(res.message)
                    }
                    that.isLoading = false;
                    that.client.content = null;
                    that.client.mobile = null;
                    that.client.name = null;
                    that.excelData = undefined;
                });
        }
        else {
            that.isLoading = false;
            return;
        }

    }

    getSmsList() {
        let from_date = moment(this.filterData['from_date']).format('YYYY-MM-DD');
        let to_date = moment(this.filterData['to_date']).format('YYYY-MM-DD');
        let client_name = this.filterData.client_name != null || this.filterData.client_name != '' ? this.filterData.client_name : '';
        let mobile = this.filterData.mobile != null || this.filterData.mobile != '' ? this.filterData.mobile : ''

        if (this.filterData.mobile != null) {
            let mobLength = this.filterData.mobile.toString().length;
            if (mobLength !== 10) {
                let toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'PLEASE ENTER 10 DIGIT MOBILE NUMBER'
                };
                this.toasterService.pop(toast);
                return
            }
        }

        this.isLoading = true;
        let params = {
            from_date: from_date,
            to_date: to_date,
            client_name: client_name != null ? client_name.trim() : '',
            mobile: mobile
        }

        let that = this;

        this.isLoadMask = this.SmsService.getSmsList(params).then(function (res: any) {
            that.smsList = res.data;
            that.isLoading = false;
        })
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/smsPanel/smsPanel.component.ts